import { render, staticRenderFns } from "./knowledge-base-tags.vue?vue&type=template&id=2e87d423&lang=pug&"
import script from "./knowledge-base-tags.vue?vue&type=script&lang=js&"
export * from "./knowledge-base-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports